import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootSaga from './rootSaga';
import authSlice from '../../auth/redux/slice';
import sharedSlice from './slice';
import ordersSearchSlice from '../../orders/redux/slice';
import accountSlice from '../../account/redux/slice';
import organizationsSearchSlice from '../../organizations/search/redux/slice';
import organizationBillingReportsSearchSlice from '../../organizationbilling/search/redux/slice';
import organizationAddEditSlice, { createOrganization, updateOrganization } from '../../organizations/add-edit/redux/slice';
import organizationBillingAddEditSlice, { createOrganizationBilling } from '../../organizationbilling/add-edit/redux/slice';
import organizationStripeBillingAddEditSlice from '../../organizationstripebilling/add-edit/redux/slice';
import usersSearchSlice from '../../users/search/redux/slice';
import usersAddEditSlice, { createUser, updateUser } from '../../users/add-edit/redux/slice';
import userGroupsSearchSlice from '../../userGroups/search/redux/slice';
import userGroupsAddEditSlice, { createUserGroup, updateUserGroup } from '../../userGroups/add-edit/redux/slice';
import kitsSlice from '../../kits/redux/slice';
import kitOrdersSlice from '../../kitOrders/redux/slice';
import platformMaintenanceSlice from '../../platformMaintenance/redux/slice';
import shipToPatientSlice from '../../shipToPatient/redux/slice';
import patientPaymentSlice from '../../patientPayment/redux/slice';
import clinicSubmissionSlice from '../../clinicSubmission/redux/slice';
import orgSwitcherSlice from '../../orgSwitcher/redux/slice';
import enterpriseStripeBillingAddEditSlice from '../../enterpriseStripeBilling/add-edit/redux/slice';
import trackingMaintenanceSlice from '../../trackingMaintenance/redux/slice';

let sagaMiddleware = createSagaMiddleware();

const store = configureStore({
    reducer: {
        auth: authSlice.reducer,
        shared: sharedSlice.reducer,
        account: accountSlice.reducer,
        ordersSearch: ordersSearchSlice.reducer,
        organizationsSearch: organizationsSearchSlice.reducer,
        organizationAddEdit: organizationAddEditSlice.reducer,
        organizationBillingAddEdit: organizationBillingAddEditSlice.reducer,
        organizationStripeBillingAddEdit: organizationStripeBillingAddEditSlice.reducer,
 	    organizationBillingReportsSearch: organizationBillingReportsSearchSlice.reducer,
        usersSearch: usersSearchSlice.reducer,
        usersAddEdit: usersAddEditSlice.reducer,
        userGroupsSearch: userGroupsSearchSlice.reducer,
        userGroupsAddEdit: userGroupsAddEditSlice.reducer,
        kits: kitsSlice.reducer,
        kitOrders: kitOrdersSlice.reducer,
        platformMaintenance: platformMaintenanceSlice.reducer,
        shipToPatient: shipToPatientSlice.reducer,
        patientPayment: patientPaymentSlice.reducer,
        clinicSubmission: clinicSubmissionSlice.reducer,
        orgSwitcher: orgSwitcherSlice.reducer,
        enterpriseStripeBillingAddEdit: enterpriseStripeBillingAddEditSlice.reducer,
        trackingMaintenance: trackingMaintenanceSlice.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        thunk: false,
        serializableCheck: {
            ignoredActions: [
                updateOrganization.type,
                createOrganization.type,
                createUser.type,
                updateUser.type,
                createUserGroup.type,
                updateUserGroup.type,
            ]
        }
    }).concat(sagaMiddleware)
});

export type ReduxRootState = ReturnType<typeof store.getState>;
sagaMiddleware.run(rootSaga);

export default store;
